import ResourceController from "controllers/ResourceController";

const tooltip = (resource, gameState) => {
  const change = ResourceController.instance().getDailyEffects(
    resource,
    gameState,
  );
  if (change === 0) return null;

  return `${change > 0 ? "+" : ""}${change} / day`;
};

export { tooltip };
